import { IAdvantage } from '~/src/features/domofon/components/Advantages';
import { IBenefit } from '~/src/features/domofon/components/Benefits';
import { IFeature } from '~/src/features/domofon/components/Features';
import { IFunctionality } from '~/src/features/domofon/components/Functionalities/FunctionalityItem';
import { ILesion } from '~/src/features/domofon/components/Lesions';
import { IQuestion } from '~/src/features/domofon/sections/QuestionsBlock';

export const domofonAdvatagesData: IAdvantage[] = [
    {
        id: 1,
        icon: require('~/static/images/domofon-new/icons/advantage_1.svg'),
        title: 'Антивандальный',
        alt: 'Замок',
    },
    {
        id: 2,
        icon: require('~/static/images/domofon-new/icons/advantage_2.svg'),
        title: 'Морозоустойчивый',
        alt: 'Снежинка',
    },
    {
        id: 3,
        icon: require('~/static/images/domofon-new/icons/advantage_3.svg'),
        title: 'Работает 24/7',
        alt: 'Глаз',
    },
];

export const domofonLesionsData: ILesion[] = [
    {
        id: 1,
        image: require('~/static/images/domofon-new/lesions/1.jpg'),
        image_webp: require('~/static/images/domofon-new/lesions/1.webp'),
        title: 'В подъезде\nпосторонние',
        alt: 'Посторонние в доме',
    },
    {
        id: 2,
        image: require('~/static/images/domofon-new/lesions/2.jpg'),
        image_webp: require('~/static/images/domofon-new/lesions/2.webp'),
        title: 'Кто-то рисует\nна стенах',
        alt: 'Рисунки на стенах',
    },
    {
        id: 3,
        image: require('~/static/images/domofon-new/lesions/3.jpg'),
        image_webp: require('~/static/images/domofon-new/lesions/3.webp'),
        title: 'Тонна рекламы\nв почтовых ящиках',
        alt: 'Рекламные буклеты в ящиках',
    },
    {
        id: 4,
        image: require('~/static/images/domofon-new/lesions/4.jpg'),
        image_webp: require('~/static/images/domofon-new/lesions/4.webp'),
        title: 'Во дворе может\nбыть небезопасно',
        alt: 'Открытый двор',
    },
];

// Для альбомного режима отображения карточки, название файла изображения в формате [число]-ls.jpeg
export const domofonBenefitsData: IBenefit[] = [
    {
        id: 1,
        isLandscape: true,
        image: require('~/static/images/domofon-new/benefits/1-ls.jpg'),
        image_webp: require('~/static/images/domofon-new/benefits/1-ls.webp'),
        title: 'Спокойствие всей семьи',
        text: `Моментальные уведомления об открытии дверей помогут быть уверенными в 
        своей безопасности.`,
        alt: 'Мать с детьми',
    },
    {
        id: 2,
        isLandscape: true,
        image: require('~/static/images/domofon-new/benefits/2-ls.jpg'),
        image_webp: require('~/static/images/domofon-new/benefits/2-ls.webp'),
        title: 'Комфорт в использовании',
        text: `Удобное приложение позволит узнать, кто пришёл, открыть дверь за пару 
        кликов, посмотреть архив пропущенных звонков и съёмок с камеры видеонаблюдения. `,
        alt: 'Девушка сидящая с телефоном',
    },
    {
        id: 3,
        isLandscape: false,
        image: require('~/static/images/domofon-new/benefits/3.jpg'),
        image_webp: require('~/static/images/domofon-new/benefits/3.webp'),
        title: 'Возможность сэкономить',
        text: `Для установки системы от Дом.ру не требуется полной замены домофонной сети. 
        Достаточно установить на двери подъезда новую панель.`,
        alt: 'Девушка звонит в дом',
    },
    {
        id: 4,
        isLandscape: false,
        image: require('~/static/images/domofon-new/benefits/4.jpg'),
        image_webp: require('~/static/images/domofon-new/benefits/4.webp'),
        title: 'Безопасность придомовой территории',
        text: `Камеры, подключенные к домофону, снимают в высоком разрешении днём и ночью — вы 
        сможете быть в курсе того, что происходит около подъезда.`,
        alt: 'Жилая площадь',
    },
    {
        id: 5,
        isLandscape: false,
        image: require('~/static/images/domofon-new/benefits/5.jpg'),
        image_webp: require('~/static/images/domofon-new/benefits/5.webp'),
        title: 'Поддержку 24/7',
        text: `Служба технической поддержки Дом.ру работает круглосуточно. Связаться в случае 
        необходимости можно через приложение, мессенджеры или по телефону. `,
        alt: 'Оператор колл-центра',
    },
];

export const domofonFunctionalitiesData: IFunctionality[] = [
    {
        id: 1,
        image: require('~/static/images/domofon-new/functionalities/1.jpg'),
        image_webp: require('~/static/images/domofon-new/functionalities/1.webp'),
        title: 'Открывайте дверь, не отрываясь от дел',
        icon: require('~/static/images/domofon-new/icons/lock.svg'),
        text: `Не бегите к двери в случае звонка, а просто нажмите кнопку на смартфоне 
        из любого уголка квартиры или поговорите по видеосвязи с посетителем у двери.`,
        alt: 'Отдых на диване',
    },
    {
        id: 2,
        image: require('~/static/images/domofon-new/functionalities/2.jpg'),
        image_webp: require('~/static/images/domofon-new/functionalities/2.webp'),
        title: 'Пользуйтесь удалённо',
        icon: require('~/static/images/domofon-new/icons/eye.svg'),
        text: `Открывайте дверь гостям, детям, курьерам, где бы вы ни находились.
        Всегда будьте в курсе, кто пользовался домофоном.`,
        alt: 'Парень с телефоном',
    },
    {
        id: 3,
        image: require('~/static/images/domofon-new/functionalities/3.jpg'),
        image_webp: require('~/static/images/domofon-new/functionalities/3.webp'),
        icon: require('~/static/images/domofon-new/icons/unlock.svg'),
        title: 'Ключи не обязательны',
        text: 'Открывайте дверь подъезда с телефона и без ключей, не касаясь домофона.',
        alt: 'Девушка с телефоном заходит в дом',
    },
];

export const domofonFeaturesData: IFeature[] = [
    {
        id: 1,
        image: require('~/static/images/domofon-new/features/1.jpg'),
        image_webp: require('~/static/images/domofon-new/features/1.webp'),
        icon: require('~/static/images/domofon-new/icons/camera.svg'),
        title: 'Смотрите, кто пришёл',
        text: 'Получайте вызов с&nbsp;видеоизображением посетителя с&nbsp;домофона в&nbsp;любой точке мира&nbsp;&mdash; везде, где есть интернет.',
        alt: 'Курьер звонит в домофон',
    },
    {
        id: 2,
        image: require('~/static/images/domofon-new/features/2.jpg'),
        image_webp: require('~/static/images/domofon-new/features/2.webp'),
        icon: require('~/static/images/domofon-new/icons/lock.svg'),
        title: 'Открывайте дверь в один клик',
        text: `Открывайте дверь в подъезд нажатием виджета на экране смартфона: 
        больше не нужно искать ключи в сумке.`,
        alt: 'Девушка с телефоном',
    },
    {
        id: 3,
        image: require('~/static/images/domofon-new/features/3.jpg'),
        image_webp: require('~/static/images/domofon-new/features/3.webp'),
        icon: require('~/static/images/domofon-new/icons/eye.svg'),
        title: 'Не упустите ни одной детали',
        text: `Камеры снимают в высоком разрешении — днём и ночью. Вы сможете рассмотреть 
        лицо гостя или номер машины, припаркованной неподалёку.`,
        alt: 'Жилая площадь',
    },
    {
        id: 4,
        image: require('~/static/images/domofon-new/features/4.jpg'),
        image_webp: require('~/static/images/domofon-new/features/4.webp'),
        icon: require('~/static/images/domofon-new/icons/qr.svg'),
        title: 'Управляйте домофоном всей семьёй',
        text: `Приглашайте членов семьи просто по QR–коду или через СМС. Домофон будет 
        звонить всем, и любой человек может ответить.`,
        alt: 'Жилая площадь',
    },
];

export const domofonQuestionsData: IQuestion[] = [
    {
        id: 1,
        question: 'Как установить домофон от Дом.ру в своем доме?',
        answers: [
            {
                text: `Чтобы установить видеодомофон для многоквартирного 
                дома и заключить договор на обслуживание, необходимо:`,
            },
            {
                title: '1) Провести собрание собственников',
                text: `Собрание собственников многоквартирного дома будет считаться правомочным, если на нём
                    будут присутствовать не менее 50% собственников квартир. Решение о подключении видеонаблюдения
                    должны принять не менее 2/3 от общего числа владельцев.`,
            },
            {
                title: '2) Результаты собрания оформить протоколом',
            },
            {
                title: '3) Заключить договор',
                text: `ВАЖНО: наши специалисты помогут организовать проведение собрания 
                без лишнего физического контакта. Обращайтесь, и мы окажем необходимую организационную и техническую 
                помощь в проведении голосования жильцов.`,
            },
        ],
    },
    {
        id: 2,
        question: 'Где скачать приложение «Умный Дом.ру» для Android?',
        answers: [
            {
                text: `Приложение можно скачать по 
                <a href="//play.google.com/store/apps/details?id=com.ertelecom.smarthome" target="_blank">ссылке</a>.`,
            },
        ],
    },
    {
        id: 3,
        question: 'Где скачать приложение «Умный Дом.ру» для iOS?',
        answers: [
            {
                text: `Приложение можно скачать по 
                <a href="//apps.apple.com/ru/app/%D1%83%D0%BC%D0%BD%D1%8B%D0%B9-%D0%B4%D0%BE%D0%BC-ru/id1373157818" target="_blank">ссылке</a>.`,
            },
        ],
    },
    {
        id: 4,
        question: 'Как оплатить услугу «Домофон»?',
        answers: [
            {
                text: `Оплатить услугу можно онлайн на сайте и в пунктах приёма платежей. 
                Подробнее по <a href="/payments" target="_blank">ссылке</a>.`,
            },
        ],
    },
];

